import Api from '../http.service';
/**
 * @param {object} payload
 * @param {number} payload.pageNumber
 * @param {number} payload.itemPerPage
 */

export const getAllProfileAllocationMe = (payload) =>
  Api.GET({
    url: `employee_allocation/profile_allocations_me/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
  });

/**
 * @param {object} payload
 * @param {number} payload.pageNumber
 * @param {number} payload.itemPerPage
 * @param {string} payload.creditId
 */
export const getAllExpansessbyCreditId = (payload) =>
  Api.GET({
    url: `employee_allocation/allocation_expenses/${payload.creditId}/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
  });

/**
 * @param {object} payload
 * @param {number} payload.pageNumber
 * @param {number} payload.itemPerPage
 */
export const getAllProfileAllocation = (payload) =>
  Api.POST({
    url: `employee_allocation/profile_allocations_all/${
      payload.pageNumber - 1
    }/${payload.itemPerPage}`,
  });

/**
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data.profileId
 * @param {number} payload.data.amount
 * @param {string} payload.data.currencyId
 * @param {number} payload.data.period
 * @param {number} payload.data.employeeAllocationStatusId
 * @param {string} payload.data.expireDate
 */
export const insert = (payload) =>
  Api.POST({ url: 'employee_allocation', data: payload.data });

/**
 * @param {object} payload
 * @param {String} payload.id
 */
export const deleteEmployee = (payload) =>
  Api.DELETE({ url: 'employee_allocation', data: payload.id });

/**
 * @param {object} payload
 * @param {object} payload.data
 * @param {string} payload.data.profileId
 * @param {number} payload.data.amount
 * @param {string} payload.data.currencyId
 * @param {number} payload.data.period
 * @param {number} payload.data.employeeAllocationStatusId
 * @param {string} payload.data.expireDate
 * @param {string} payload.data.id
 */
export const update = (payload) =>
  Api.PUT({ url: 'employee_allocation', data: payload.data });
/**
 * @param {object} payload
 * @param {number} payload.pageNumber
 * @param {number} payload.itemPerPage
 * @param {String} payload.profileId
 */
export const getAllEmployeeCreditByProfileId = (payload) =>
  Api.GET({
    url: `employee_allocation/profile_allocations/${payload.profileId}/${payload.pageNumber}/${payload.itemPerPage}`,
  });
